import React, { useState } from 'react';
import { CommomContainer, FAQSection, FAQContainer, FAQTitle, Question, QuestionText, Answer } from './styled';

// Dados das perguntas e respostas — TiqChat
const faqData = [
  {
    question: "O que é o TiqChat?",
    answer: "O TiqChat é uma plataforma de entretenimento que usa Inteligência Artificial para recriar personagens bíblicos — Salomão, Davi, Ester e Daniel. Você conversa com eles de forma leve e divertida sobre qualquer assunto: vida, decisões, curiosidades, fé. É como se esses personagens que você já conhece da Bíblia pudessem responder do jeito deles. Não é nada religioso no sentido formal — é entretenimento saudável com um toque de sabedoria."
  },
  {
    question: "É grátis para começar?",
    answer: "Sim! O plano gratuito permite até 20 mensagens por dia com Salomão e Davi, sem precisar colocar cartão de crédito. Quando quiser acesso ilimitado a todos os personagens e idiomas, você pode assinar o plano Premium por R$ 24,90/mês."
  },
  {
    question: "Quem são os personagens?",
    answer: "São quatro personalidades bíblicas recriadas com IA: Rei Salomão (sabedoria e estratégia), Rei Davi (coragem e fé), Rainha Ester (graça e determinação) e Profeta Daniel (fé e propósito). Cada um tem seu jeito único de conversar e responder."
  },
  {
    question: "Posso falar sobre qualquer assunto, ou só sobre a Bíblia?",
    answer: "Você pode conversar sobre muitos temas — de fé e histórias bíblicas a dúvidas e situações do dia a dia. O que torna o TiqChat único é que cada personagem sempre responde a partir da visão de mundo da Bíblia, trazendo passagens que apoiam o que diz. Lembrando: é uma experiência de entretenimento criada por inteligência artificial — não substitui a leitura da Bíblia nem orientação profissional."
  },
  {
    question: "Em quais idiomas posso conversar?",
    answer: "O TiqChat suporta mais de 10 idiomas: Português, Inglês, Espanhol, Hebraico, Grego, Latim, Francês, Alemão, Japonês, Mandarim, Italiano e Coreano. O plano Premium libera todos os idiomas, incluindo os originais bíblicos."
  },
  {
    question: "Como funciona o Modo Praticar Idiomas?",
    answer: "É um bônus para quem já estuda um idioma e quer praticar conversação. Você escolhe o idioma (inglês, espanhol, hebraico, grego e mais), e o personagem bíblico conversa com você naquele idioma — corrigindo seus erros e explicando em português. É como ter um tutor paciente disponível a qualquer hora."
  },
  {
    question: "É possível cancelar a assinatura a qualquer momento?",
    answer: "Sim. Você pode cancelar sua assinatura a qualquer momento diretamente pelo seu perfil no site, sem multa e sem burocracia."
  },
  {
    question: "Quais são os métodos de pagamento aceitos?",
    answer: "Aceitamos pagamentos via cartão de crédito diretamente pelo site. Para pagamento via PIX, entre em contato pelo nosso WhatsApp: (16) 98202-6554."
  },
  {
    question: "Em quais dispositivos o TiqChat funciona?",
    answer: "O TiqChat funciona no navegador de qualquer dispositivo: computador (Windows, Mac), celular (Android e iOS) e tablet. Não precisa instalar nenhum aplicativo — é só acessar o site tiqchat.com."
  },
  {
    question: "As conversas são privadas?",
    answer: "Sim. Suas conversas ficam guardadas apenas no aparelho que você está usando (celular ou computador) — nós não armazenamos seu histórico em nossos servidores. Por isso, se você limpar os dados do navegador ou trocar de aparelho, o histórico não é transferido. É o seu espaço, no seu dispositivo."
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Função para alternar entre mostrar e esconder a resposta
  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <FAQSection>
    <FAQContainer>
      <FAQTitle>Perguntas Frequentes sobre o TiqChat</FAQTitle>
      {faqData.map((item, index) => (
        <div key={index}>
          <Question
            onClick={() => toggleAnswer(index)}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggleAnswer(index)}
            role="button"
            tabIndex={0}
            aria-expanded={activeIndex === index}
          >
            <QuestionText>{item.question}</QuestionText>
            <span aria-hidden="true" style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#FF9900', flexShrink: 0 }}>
              {activeIndex === index ? '−' : '+'}
            </span>
          </Question>
          {activeIndex === index && <Answer>{item.answer}</Answer>}
        </div>
      ))}
        {/* <CommomContainer>
        <QuestionText>JoinKids - Todos os direitos reservados</QuestionText>
        </CommomContainer> */}
    
    </FAQContainer>
    </FAQSection>
  );
};

export default FAQ;
